import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup, Input } from 'barnyard/components';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';

const SUPPLIERS = {
  COVETRUS: {
    id: 1,
    short_name: 'Covetrus'
  }
};

const WrongBillToRule = (props) => {
  const {
    form, onSubmit, initialValues, ...other
  } = props;

  const [bill_to, setBillTo] = useState(initialValues.bill_to || '');
  const [days_lookback, setDaysLookback] = useState(initialValues.days_lookback || 7);
  const [supplier, setSupplier] = useState(initialValues.supplier || SUPPLIERS.COVETRUS.id);

  const submit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'wrong_bill_to',
      value: {
        bill_to,
        days_lookback,
        supplier
      }
    });
  }, [bill_to, days_lookback, onSubmit, supplier]);

  const onReset = useCallback(() => {
    setBillTo(initialValues.bill_to || '');
    setDaysLookback(initialValues.days_lookback || 7);
    setSupplier(initialValues.supplier || SUPPLIERS.COVETRUS.id);
  }, [initialValues]);


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineSupplierSelect
        eligibleSuppliers={SUPPLIERS}
        value={supplier}
        onChange={setSupplier}
        include_all={false}
        include_any={false}
        label='Supplier'
        description='Supplier for the bill to'
      />
      <InlineInputGroup
        label='Bill To'
        description='Which bill to should clinics use for the supplier'
        type='text'
        InputComponent={Input}
        value={bill_to}
        onChange={setBillTo}
        placeholder='Bill To'
      />
      <InlineInputNumber
        label='Days Lookback'
        description='How many days to lookback'
        value={days_lookback}
        onChange={setDaysLookback}
      />
    </RuleForm>
  );
};

WrongBillToRule.defaultProps = {
  initialValues: {}
};

WrongBillToRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
};

export default WrongBillToRule;
